export default "__VITE_ASSET__BONbDCnq__"